import { Dialog, DialogContent } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ButtonUiKit from "src/components/UI/button";
import InputTextFieldUI from "src/components/UI/inputTextField/inputTextField";
import { IObject } from "src/models/interfaces";
import CircularProgressWithLabel from "./circularProgressWithLabel";
import { PatientServices } from "src/services/Patient";
import { smsService } from "src/services/Sms";
import { IModalProps } from "src/models/interfaces/IModalProps";

interface IProps extends IModalProps {
    mobile: string;
    onSubmit: (code: string) => void
}

const VerifyConfirmeCode: FC<IProps> = ({ mobile, open, onClose, onSubmit }) => {
    const { register, handleSubmit, formState: { errors } } = useForm();

    const { getConfirmationCodeAnonymous } = smsService();

    const [timer, setTimer] = useState(180);

    const reSendVerifyCode = async () => {
        
        await getConfirmationCodeAnonymous(mobile);
        setTimer(180)
    }

    const submitCode = async (value: IObject) => {

        onSubmit(value.code);
        onClose();

    }

    useEffect(() => {
        let myInterval = setInterval(() => {
            if (timer > 0) {
                setTimer(timer - 1);
            }
            else {
                clearInterval(myInterval)
            }


        }, 1000)
        return () => {
            clearInterval(myInterval);
        };

    })

    return (
        <Dialog open={open} onClose={onClose} >
            <DialogContent className="flex flex-col items-center gap-3">
                <p className="text-[0.9rem]">
                    کد تایید به شماره شما ارسال شد. لطفا آن را وارد نمایید.
                </p>
                <form>
                    <InputTextFieldUI
                        disabled={timer === 0}
                        fullWidth
                        name="code"
                        register={register}
                        validation={{ required: true }}
                        error={!!errors.code}
                    />
                </form>
                {timer != 0 && <div>
                    <CircularProgressWithLabel value={timer} maxValue={180} size={60} color="info" />
                </div>}
                <div className="flex justify-center items-center gap-2 w-full">
                    {
                        timer === 0 ?
                            <ButtonUiKit fullWidth onClick={reSendVerifyCode}>
                                دریافت مجدد کد تایید
                            </ButtonUiKit> :
                            <ButtonUiKit fullWidth onClick={handleSubmit(submitCode)}>
                                تایید
                            </ButtonUiKit>
                    }
                    <ButtonUiKit fullWidth color="error" onClick={onClose}>
                        انصراف
                    </ButtonUiKit>
                </div>


            </DialogContent>
        </Dialog>
    )
}
export default VerifyConfirmeCode;